import React from 'react';

import styles from './styles.module.scss';

import Button from '@components/_shared/button';
import ImageBackground from '@components/_shared/imageBackground';
import { colors } from '@utils/constants/colors';
import { Logo } from '@assets/icons';
import { ListItemCheck, ListItemPlus } from '@assets/icons';
import { FeeStructureLandingType } from '@utils/types/landings';

const FeeStructureHero = (
  props: Pick<FeeStructureLandingType, 'title' | 'subtitle' | 'cta' | 'plans'>
) => {
  const { title, subtitle, cta, plans } = props;

  const onGetStartedClick = () => {
    const container = document.getElementById('contact');
    window.scrollTo({
      top: (container?.offsetTop || 200) - 200,
      behavior: 'smooth',
    });
  };

  return (
    <>
      <ImageBackground
        containerStyle={styles.hero}
        backgroundImageStyle={`
          url('/images/fee-structure-hero-bg.png')
        `}
      >
        <div className={styles.hero__wrapper}>
          <h1 className={styles.hero__title}>{title}</h1>
          <div className={styles.hero__subtitle}>{subtitle}</div>
          <Button
            onClick={onGetStartedClick}
            containerStyle={styles.hero__cta}
            variant="greenContained"
          >
            {cta}
          </Button>
        </div>
      </ImageBackground>

      <div className={styles.plans}>
        <h3 className={styles.plans__title}>{plans.title}</h3>

        <div className={styles.plans__wrapper}>
          <div className={styles.plan}>
            <div className={styles.plan__header}>
              <div className={styles.plan__title}>
                <Logo fill={colors.roveWhite} />
                Lite
              </div>
              <div className={styles.plan__fee}>{plans.roveLiteFee}% fee</div>
            </div>

            <div className={styles.plan__subtitle}>{plans.subtitle}</div>

            <div className={styles.plan__items}>
              {plans.roveLiteBenefits.map((benefit) => (
                <div key={benefit} className={styles.plan__item}>
                  <ListItemCheck />
                  {benefit}
                </div>
              ))}
            </div>
          </div>

          <div className={styles.plan}>
            <div className={styles.plan__header}>
              <div className={styles.plan__title}>
                <Logo fill={colors.roveWhite} />+
              </div>
              <div className={styles.plan__fee}>{plans.rovePlusFee}% fee</div>
            </div>

            <div className={styles.plan__subtitle}>{plans.subtitle}</div>

            <div className={styles.plan__items}>
              <div className={styles.plan__item}>
                <ListItemCheck />
                All the benefits of Rove Lite
              </div>
            </div>

            <div className={styles.plan__innerItems}>
              <div className={styles.plan__subtitle}>
                {plans.rovePlusSubtitle}
              </div>
              {plans.rovePlusBenefits.map((benefit) => (
                <div key={benefit} className={styles.plan__item}>
                  <ListItemPlus />
                  {benefit}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FeeStructureHero;
